import { render, staticRenderFns } from "./PDFViewerComponent.vue?vue&type=template&id=54812710&"
import script from "./PDFViewerComponent.vue?vue&type=script&lang=js&"
export * from "./PDFViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./PDFViewerComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports